import React, { useContext, useState } from 'react';

import styled from 'styled-components';

import { getNow } from '@libs/NwMoment';

import { ListContext } from '@contexts/ListContext';

import CustomSelect from '@components/Gui/NwForm/CustomSelect';
import FilterClearButton from '@components/Gui/NwForm/FilterClearButton';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
`;

const LegalYearlyStatusFilter = ({ onChange, value }) => {
    //const [controlValue, setControlValue] = useState(value);

    const { cachedList } = useContext(ListContext);
    const legalTypes = cachedList.legalTypes.items;
    const documentTypeOptions = [
        { value: null, label: 'Select a document type' },
        ...legalTypes.filter((x) => x.YearlyRequired).map((type) => ({ value: type.Code, label: type.Name })),
    ];
    const currentYear = getNow().year();
    //year options: last ten years and next ten years
    const yearOptions = [
        { value: null, label: 'Select a year' },
        ...Array.from({ length: 20 }, (_, i) => ({
            value: currentYear - 10 + i,
            label: (currentYear - 10 + i).toString(),
        })),
    ];

    const handleChangeType = (selectedValue) => {
        if (!selectedValue) {
            onChange([null, null]);
        } else {
            if (!value[1]) {
                onChange([selectedValue, currentYear]);
            } else {
                onChange([selectedValue, value[1]]);
            }
        }
    };

    const handleChangeYear = (selectedValue) => {
        onChange([value[0], selectedValue]);
    };

    const clearFilter = () => {
        onChange([null, null]);
    };

    return (
        <Wrapper>
            <CustomSelect value={value[0]} onChange={handleChangeType} options={documentTypeOptions} />
            <CustomSelect value={value[1]} onChange={handleChangeYear} options={yearOptions} disabled={!value[0]} />
            <FilterClearButton onClick={clearFilter} />
        </Wrapper>
    );
};

export default LegalYearlyStatusFilter;
